var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": ".98rem" } },
    [
      _c("topbar", { attrs: { text: "修改手机号" } }),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox" }, [
        _c("div", { staticClass: "itemBox" }, [
          _c("div", { staticClass: "name" }, [_vm._v("新手机号")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userPhone,
                expression: "userPhone"
              }
            ],
            attrs: { type: "text", placeholder: "请输入新手机号码" },
            domProps: { value: _vm.userPhone },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.userPhone = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "itemBox" }, [
          _c("div", { staticClass: "name" }, [_vm._v("验证码")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.code,
                expression: "code"
              }
            ],
            attrs: { type: "text", placeholder: "请输入手机验证码" },
            domProps: { value: _vm.code },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.code = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _vm.status === 0
            ? _c(
                "div",
                { staticClass: "send", on: { click: _vm.getSmsAuthCode } },
                [_vm._v("获取验证码")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.status === 1
            ? _c("div", { staticClass: "send" }, [_vm._v(_vm._s(_vm.num))])
            : _vm._e(),
          _vm._v(" "),
          _vm.status === 2
            ? _c(
                "div",
                { staticClass: "send", on: { click: _vm.getSmsAuthCode } },
                [_vm._v("重新获取")]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btn", on: { click: _vm.sure } }, [
        _vm._v("确定")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e94e284", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e94e284","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/changePhone.vue
// module id = null
// module chunks = 